<button mat-button
        mat-icon-button
        type="button"
        class="alerts-button"
        aria-label="Alerts"
        matTooltip="Notifications"
        (click)="toggleAlertsSidenav()">
  <mat-icon [ngClass]="statusClass">{{statusIcon}}</mat-icon>
</button>
